import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
} from "reactstrap";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import { convertToLowestUnit, ExportAvailableInCSVForReports, exportFromula, GetUpdatedDelivered, mapUnits, formatUnitsForReport } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";
import AddOpeningComp from "./AddOpeningComp";
import BatchWithdrawModal from "../../../../components/BatchWithdrawModal";
import { findEarliestExpiringBatches } from "../../../../helpers/batchWithdrawl";
import ExpiryChangePopup from "../../../../components/ExpiryChangeModal";

const ViewInventory = (props) => {

  const { SearchBar } = Search;
  const is_manual_entry_allowed = localStorage.getItem("is_manual_entry_allowed") == "true";

  useEffect(() => {
    loadProducts();
    loadSections();
  }, []);
  const [allSections, setAllSections] = useState([]);
  const loadSections = async () => {
    let url = process.env.REACT_APP_BASEURL + "productsections/getall";
    const response = await postSubmitForm(url, {});
    if (response && response.status === 1) {
      setAllSections(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allProducts, setAllProducts] = useState([]);
  const [allProductsFiltered, setAllProductsFiltered] = useState([]);
  const loadProducts = async () => {
    preloader(true);
    let url = process.env.REACT_APP_BASEURL + "stores/getinventory";
    const response = await postSubmitForm(url, {type:"product"});
    if (response && response.status === 1) {
      preloader(false);
      setAllProducts(response.data);
    } else {
      preloader(false);
      showNotification(response.message, "Error");
    }
  };
  const [selectedSection, setSelectedSection] = useState("All");
  useEffect(() => {
    if (selectedSection) {
      if (selectedSection === "All") {
        setAllProductsFiltered(allProducts);
      } else {
        var data = JSON.parse(JSON.stringify(allProducts));
        setAllProductsFiltered(
          data.filter((prod) => prod.section === selectedSection)
        );
      }
    }
  }, [allProducts, selectedSection]);


  const [transactionsModal, setTransactionsModal] = useState();
  const [selectedProduct, setSelectedProduct] = useState();
  const [selectedProduct_Transactions, setSelectedProduct_Transactions] = useState([]);
  const handleViewDetailsClick = async (row) => {
    let url =
      process.env.REACT_APP_BASEURL +
      "branchproductinventories/get_by_product_id";
    const response = await postSubmitForm(url, { product_id: row.product_id });
    if (response && response.status === 1) {
      setSelectedProduct_Transactions(response.data);
      setSelectedProduct(row);

      setTransactionsModal(true);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [selectedProductToAdd, setSelectedProductToAdd] = useState();
  const [addInventoryModal, setAddInventoryModal] = useState(false);
  function editFormatter(cell, row) {
    return (
      <>
      <span className="text-info">
        <i
          className="mdi mdi-text-box-search font-size-15 mr-2"
          title="View Details"
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleViewDetailsClick(row);
          }}
        ></i>
      </span>
      <span  style={{ display: is_manual_entry_allowed ? 'inline' : 'none' }}>
      <i
        className="mdi mdi-cart-plus font-size-15"
        title="Add Opening Inventory"
        style={{ cursor: "pointer" }}
        onClick={() => {
          setSelectedProductToAdd(row);
          setAddInventoryModal(!addInventoryModal);
        }}
      ></i>
    </span>
    </>
    );
  }
  function checkValues(arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].value > 0) {
        return true;
      }
    }
    return false;
  }
  const columns = [
    {
      dataField: "_id",
      hidden: true,
      csvExport: false,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      csvExport: false,
    },

    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "section",
      text: props.t("Section"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell,row)=>{
        return mapUnits(row.unit_levels)
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "threshold",
      text: props.t("Threshold"),
      formatter: (cell, row, rowIndex) => {
        return row.threshold + " " + row.unit_for_threshold;
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "available",
      text: props.t("Available"),
      sort: true,
      formatter:(cell,row)=>{
        let threshold = convertToLowestUnit(row?.unit_levels,[{unit:row?.unit_for_threshold,value:row?.threshold}]);
        let totalAvailable =   convertToLowestUnit(row?.unit_levels,row?.available)
 
      if (totalAvailable<=threshold) {
        return (
          <span
          style={{
            whiteSpace: "normal",
            display: "inline-block",
            maxWidth: "100%",
          }}
          className="font-size-12 badge-soft-danger badge badge-danger badge-pill mr-1 mb-1"
        >
          {formatUnitsForReport(row?.available,row?.unit_levels)}
        </span>
        );
      } else {
        return formatUnitsForReport(row.available,row.unit_levels);
      }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

   

    {
      text: props.t("Action"),
      formatter: editFormatter,
      csvExport: false,
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState();
  const [withdrawModal, setWithrdrawModal] = useState();
  const [discardWasteModal, setDiscardWasteModal] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const handleWithdrawClicked = async (quantity) => {
    if(quantity.length<=0){
      showNotification("Please enter a valid quantity ","Warning")
      return
    }
    let convertedQuantity = GetUpdatedDelivered(quantity,selectedProduct.unit_levels)
    const isInvalidTransfer = convertedQuantity.every(item => item.value == 0 );
    if (isInvalidTransfer) {
      showNotification("Can't transfer product with value 0 and checked", "Warning");
      return;
    }
    const object = {
      branchproductinventory_id: selectedBatch._id,
      quantity: convertedQuantity.map(({unit,value})=>({unit,value})),
    };
    setIsLoading(true)
    let url = process.env.REACT_APP_BASEURL + "branchproductinventories/withdraw";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      setIsLoading(false)
      showNotification(response.message, "Success");
      loadProducts();
      setSelectedBatch()
      setTransactionsModal(!transactionsModal);
      setWithrdrawModal(!withdrawModal);
      return true
    } else {
      setIsLoading(false)
      showNotification(response.message, "Error");
      return false
    }
  };
  const handleDiscardAsWaste = async (quantity) => {
    if(quantity.length<=0){
      showNotification("Please enter a valid quantity ","Warning")
      return
    }
    let convertedQuantity = GetUpdatedDelivered(quantity,selectedProduct.unit_levels)
    const isInvalidTransfer = convertedQuantity.every(item => item.value == 0 );
    if (isInvalidTransfer) {
      showNotification("Cannot discard product with value 0 and checked", "Warning");
      return;
    }
    const object = {
      branchproductinventory_id: selectedBatch._id,
      quantity: convertedQuantity.map(({unit,value})=>({unit,value})),
    };
    setIsLoading(true)
    let url =  process.env.REACT_APP_BASEURL + "branchproductinventories/mark_wasted";
    const response = await postSubmitForm(url, object);
    if (response && response.status === 1) {
      showNotification(response.message, "Success");
      setIsLoading(false)
      setTransactionsModal(!transactionsModal);
      setDiscardWasteModal(!discardWasteModal);
      loadProducts();
      setSelectedBatch()
      setSelectedRowsUnit([])
      return true
    } else {
      setIsLoading(false)
      showNotification(response.message, "Error");
      return false
    }
  };

  const [dateChangeModal, setDateChangeModal] = useState(false);
  const [selectedRowForDateChange, setSelectedRowForDateChange] = useState(null);
  const handleExpiryDateChange = async (newDate) => {
    try {
      if (!newDate) {
        showNotification("Please select a valid date", "Warning");
        return;
      }
      preloader(true);
      const url =
        process.env.REACT_APP_BASEURL +
        "storeproductinventories/update_expiry_date";
      const payload = {
        id: selectedRowForDateChange._id,
        batch: selectedRowForDateChange.batch,
        expiry_date: moment(newDate).format("YYYY-MM-DD"),
      };
      const response = await postSubmitForm(url, payload);
      if (response && response.status === 1) {
        showNotification("Expiry date updated successfully", "Success");
        handleViewDetailsClick(selectedProduct);
        setDateChangeModal(false);
        setSelectedRowForDateChange(null);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification("Error updating expiry date", "Error");
    } finally {
      preloader(false);
    }
  };
  const columns_transaction = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "quantity",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity)
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Cost Price"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "selling_price",
      text: props.t("Selling Price"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "remarks",
    //   text: props.t("Remarks"),
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
    {
      text: props.t("Expiry Date"),
      sort: false,
      formatter: (cell, row) => {
        if (row.expiry_date) {
          return moment(row.expiry_date).format("DD/MM/YYYY HH:mm");
        } else {
          return (
            <>
              <span className="text-info d-flex align-items-center justify-content-center"
                style={{cursor:"pointer"}}
                onClick={() => {
                  setSelectedRowForDateChange(row);
                  setDateChangeModal(true);
                }}
              >
                <i className="bx bxs-edit font-size-15" />
              </span>
            </>
          );
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      text: props.t("Withdraw"),
      formatter: (cell, row) => {
        // Finding earliest expiring batches
        const earliestBatches = findEarliestExpiringBatches(selectedProduct_Transactions || []);
        // Checking if current row is in earliest batches
        const isEarliestBatch = earliestBatches.some(
          batch => batch._id === row._id
        );
        // Check if the batch has quantity
        const hasQuantity = row.quantity.some(q => q.value > 0);
        const isDisabled = row.expiry_date && !(isEarliestBatch && hasQuantity);
        return (
          <span className={`text-info ${isDisabled ? 'text-muted' : ''}`}>
            <i
              className={`bx bx-download font-size-22 ${isDisabled ? 'text-secondary' : ''}`}
              title="Withdraw"
              style={{
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                opacity: isDisabled ? 0.5 : 1
              }}
              onClick={() => {
                if(!isDisabled){
                  setSelectedBatch(row);
                  setWithrdrawModal(!withdrawModal);
                }
              }}
            ></i>
          </span>
      )},
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Mark Wasted"),
      formatter: (cell, row) => {
        return checkValues(row.quantity) ? (

          <span className="text-info">
            <i
              className="bx bxs-trash font-size-22"
              title="Move to Waste"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setSelectedBatch(row);
                setDiscardWasteModal(!withdrawModal);
              }}
            ></i>
          </span>
        ) : (
          <span className="text-info">Out of stock</span>
        );
      },
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
  ];
  const pagination_options = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
      {
        text: "All",
        value:
          selectedProduct_Transactions && selectedProduct_Transactions.length,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
    hideSizePerPage: true,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "finished_product_inventory";
    const exportType = "xls";

    let data_to_export = allProducts;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          Name: v.name,
          Section: v.section,
          Category: v.category,
          formula: v.unit_levels && exportFromula(v.unit_levels),
          Threshold: v.threshold + " " + v.unit_for_threshold,
          Available: ExportAvailableInCSVForReports(v.available),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Finished Product Inventory")}
            title={props.t("Inventory")}
            breadcrumbItem1={props.t("Finished Products")}
            breadcrumbItem2={props.t("View Inventory")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="printDiv">
                    <CardTitle className="text-center">
                      {props.t("Finished Product Inventory")}
                    </CardTitle>

                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allProductsFiltered && allProductsFiltered}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                      exportCSV
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={5}></Col>
                            <Col lg={3}>
                              {" "}
                              <select
                                name="section"
                                className="form-control"
                                value={selectedSection}
                                onChange={(e) => {
                                  setSelectedSection(e.target.value);
                                }}
                              >
                                <option value="All">All</option>
                                {allSections &&
                                  allSections.map((section) => {
                                    return (
                                      <option value={section.section}>
                                        {section.section}
                                      </option>
                                    );
                                  })}
                              </select>
                            </Col>{" "}
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                  <Modal
                    size="lg"
                    style={{
                      width: "940px",
                      maxWidth: "950px",
                    }}
                    isOpen={transactionsModal}
                    toggle={() => setTransactionsModal(!transactionsModal)}
                  >
                    <ModalHeader
                      toggle={() => setTransactionsModal(!transactionsModal)}
                    >
                      Product Name: {selectedProduct && selectedProduct.name}
                    </ModalHeader>
                    <ModalBody>
                      {selectedProduct && (
                        <>
                          <Row>
                            <Col lg={12}>
                              <Card>
                                <CardBody>
                                  <Row>
                                    <Col lg={12}>
                                      <ToolkitProvider
                                        keyField="_id"
                                        data={
                                          selectedProduct_Transactions &&
                                          selectedProduct_Transactions
                                        }
                                        columns={columns_transaction}
                                      >
                                        {(props) => (
                                          <div>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              pagination={paginationFactory(
                                                pagination_options
                                              )}
                                              noDataIndication="No data to display."
                                              striped
                                              hover
                                              condensed
                                            />
                                          </div>
                                        )}
                                      </ToolkitProvider>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        </>
                      )}
                    </ModalBody>
                  </Modal>

                  {/* ---Withdraw inventory start--- */}
                  <BatchWithdrawModal
                    isOpen={withdrawModal}
                    toggle={() => {setWithrdrawModal(false);setSelectedBatch()}}
                    onSubmit={handleWithdrawClicked}
                    item={selectedProduct}
                    isLoading={isLoading}
                    checkLimitFor={"batch"}
                    selectedBatch={selectedBatch}
                  />
                   {/* ---Withdraw inventory end--- */}

                  {/* ---Waste Modal Start--- */}
                  <BatchWithdrawModal
                    isOpen={discardWasteModal}
                    toggle={()=>{setDiscardWasteModal(false);setSelectedBatch()}}
                    onSubmit={handleDiscardAsWaste}
                    item={selectedProduct}
                    isLoading={isLoading}
                    checkLimitFor={"batch"}
                    selectedBatch={selectedBatch}
                  />
                 
                   {/* ---Waste Modal End--- */}

                   {/* add inventory modal starts */}
                  <Modal
                    size="lg"
                    style={{
                      width: "940px",
                      maxWidth: "950px",
                    }}
                    isOpen={addInventoryModal}
                    toggle={() => setAddInventoryModal(!addInventoryModal)}
                  >
                    <ModalHeader
                      toggle={() => setAddInventoryModal(!addInventoryModal)}
                    >
                      Add Inventory
                    </ModalHeader>
                    <ModalBody>
                      <AddOpeningComp
                        isRefreshData={true}
                        refreshData={loadProducts}
                        selectedProduct={selectedProductToAdd}
                        handleClosePopup={() =>
                          setAddInventoryModal(false)
                        }
                      />
                    </ModalBody>
                  </Modal>

                  {/* add inventory modal ends */}

                                    {/* ---Expiry Date Modal Start--- */}
                    <ExpiryChangePopup
                    isOpen={dateChangeModal}
                    toggle={() => {
                      setDateChangeModal(false);
                      setSelectedRowForDateChange(null);
                    }}
                    onSubmit={handleExpiryDateChange}
                    initialDate={selectedRowForDateChange?.expiry_date}
                    title="Change Expiry Date"
                  />
                  {/* ---Expiry Date Modal End--- */}


                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewInventory))
);
